import { LegalContent } from './LegalContent';
import { LegalPage } from './LegalPage';
import { TERMS_AND_CONDITIONS_CONTENT } from './termsAndConditionsContent';

export function TermsAndConditionsPage() {
  return (
    <LegalPage title="Terms & Conditions" updated="Last updated: August 2025">
      <LegalContent blocks={TERMS_AND_CONDITIONS_CONTENT} />
    </LegalPage>
  );
}
